"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowListPanel = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const WorkflowMenuButton_1 = __importDefault(require("../components/WorkflowMenuButton"));
const CreateWorkflowDialog_1 = __importDefault(require("../dialogs/CreateWorkflowDialog"));
const WorkflowBuilderContext_1 = require("../WorkflowBuilderContext");
const StyledPanel = (0, styled_components_1.default)(core_ui_1.Panel) `
  .tree-label {
    display: flex;
    align-items: center;
  }
  .more-icon {
    font-size: 18px;
  }
  .deleted-item {
    color: ${props => props.theme.palette.error.main};
  }
  .flex-end {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0 12px 0 6px;
  }
`;
const WorkflowListPanel = () => {
    const [includeDeleted, setIncludeDeleted] = (0, use_query_params_1.useQueryParam)('deleted', (0, use_query_params_1.withDefault)(use_query_params_1.BooleanParam, false));
    const [isOpenDialog, setIsOpenDialog] = (0, react_1.useState)(false);
    const [menuAnchor, setMenuAnchor] = (0, react_1.useState)(null);
    const { workflowList, selectedWorkflow, setSelectedWorkflow, findWorkflows } = (0, WorkflowBuilderContext_1.useWorkflowBuilderContext)();
    const findWorkflowWithParams = () => {
        findWorkflows({ includeDeleted });
    };
    return (react_1.default.createElement(StyledPanel, { className: 'workflow-list' },
        react_1.default.createElement(core_ui_1.PanelHeader, { accessory: react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: e => setMenuAnchor(e.currentTarget) },
                react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")) },
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Workflows"),
            react_1.default.createElement(core_1.Menu, { keepMounted: true, id: 'workflow-more-menu', open: !!menuAnchor, anchorEl: menuAnchor, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setMenuAnchor(null) },
                react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                        setIsOpenDialog(true);
                        setMenuAnchor(null);
                    } }, "Add Workflow"),
                react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                        setIncludeDeleted(!includeDeleted);
                        setMenuAnchor(null);
                    } },
                    includeDeleted ? 'Hide' : 'Show',
                    " Deleted"))),
        react_1.default.createElement(core_ui_1.PanelContent, null, workflowList && (react_1.default.createElement(lab_1.TreeView, { selected: (selectedWorkflow === null || selectedWorkflow === void 0 ? void 0 : selectedWorkflow.id.toString()) || '', defaultCollapseIcon: react_1.default.createElement(core_1.Icon, null, "arrow_drop_down"), defaultExpandIcon: react_1.default.createElement(core_1.Icon, null, "arrow_right") }, workflowList.data.map(workflow => (react_1.default.createElement(lab_1.TreeItem, { key: workflow.id, nodeId: workflow.id.toString(), className: workflow.isDeleted ? 'deleted-item' : undefined, label: react_1.default.createElement("div", { className: 'tree-label' },
                workflow.name,
                react_1.default.createElement("div", { className: 'flex-end' },
                    react_1.default.createElement(WorkflowMenuButton_1.default, { workflow: workflow, onChange: findWorkflowWithParams }))), onClick: () => setSelectedWorkflow(workflow) })))))),
        react_1.default.createElement(CreateWorkflowDialog_1.default, { open: isOpenDialog, onCancel: () => setIsOpenDialog(false), onCreated: workflow => {
                findWorkflowWithParams();
                setIsOpenDialog(false);
                setSelectedWorkflow(workflow);
            } })));
};
exports.WorkflowListPanel = WorkflowListPanel;
exports.default = exports.WorkflowListPanel;
//# sourceMappingURL=WorkflowListPanel.js.map